import { SuitesType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueSuitesTableRow } from './components';
import { venueSuitesRows } from './data';

type VenueSuitesTablePropsType = {
  venueSuites: SuitesType;
};

export const VenueSuitesTable: React.FC<VenueSuitesTablePropsType> = ({
  venueSuites,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueSuitesRows.map((row) => (
          <VenueSuitesTableRow
            key={row.label}
            venueSuites={venueSuites}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
